

export const checkSubUser = () => {
    if(sessionStorage.getItem('isSubUser') === null) return false;
    return sessionStorage.getItem('isSubUser') === 'true';
}

